import type { WindowName, WindowsInfo } from '@/api/types';

export const WINDOWS: { key: WindowName; label: string; days: number | null }[] = [
  { key: 'before', label: 'Before (30 days)', days: null },
  { key: 'during', label: 'During', days: null },
  { key: 'after7', label: 'After 7 days', days: 7 },
  { key: 'after30', label: 'After 30 days', days: 30 },
];

// Names a window the way the report defines it, and says so when it has not fully elapsed:
// a half-elapsed D30 must never read as final.
export function windowHeading(info: WindowsInfo, key: WindowName, label: string): string {
  const window = info[key];
  if (!window.partial) return label;
  if (key === 'during') return `${label} (still running)`;
  if (key === 'after7' || key === 'after30') {
    const total = key === 'after7' ? 7 : 30;
    return `${label} (partial: ${info[key].daysAvailable} of ${total} days)`;
  }
  return label;
}
